import React from 'react';
import { toast } from 'react-toastify';

import ErrorBox from '../components/widgets/presentational/ErrorBox';

export const toastError = err => toast.error(<ErrorBox error={err} size={ErrorBox.SIZES.small} />);
